import { useSelector } from 'react-redux';

import { selectFilters } from 'shared/selectors';
import { EOfferType } from 'shared/types/features';

export type TUseHostFiltersResult = {
  offerType: EOfferType;
};

export const useHostFilters = (): TUseHostFiltersResult => {
  const { offerType } = useSelector(selectFilters);

  if (!offerType) {
    throw new Error('Host filters must be defined');
  }

  return { offerType };
};
